// extracted by mini-css-extract-plugin
module.exports = {"popover_content":"bopis_popover_content__AU6yO","popover_text":"bopis_popover_text__03ATO"};